var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmirationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 28.4168C17.6965 28.419 19.3768 28.0859 20.9442 27.4367C22.5116 26.7874 23.9352 25.8348 25.1333 24.6335C26.3345 23.4355 27.2872 22.0118 27.9364 20.4444C28.5857 18.877 28.9188 17.1967 28.9166 15.5002C28.9188 13.8036 28.5856 12.1234 27.9364 10.5559C27.2871 8.98854 26.3345 7.56489 25.1333 6.3668C23.9352 5.16557 22.5116 4.21294 20.9442 3.56368C19.3768 2.91441 17.6965 2.58131 15.9999 2.58351C14.3034 2.58134 12.6231 2.91447 11.0557 3.56373C9.4883 4.21299 8.06464 5.16559 6.86655 6.3668C5.66535 7.56489 4.71275 8.98854 4.06348 10.5559C3.41422 12.1234 3.0811 13.8036 3.08326 15.5002C3.08106 17.1967 3.41417 18.877 4.06343 20.4444C4.7127 22.0118 5.66532 23.4355 6.86655 24.6335C8.06464 25.8347 9.4883 26.7874 11.0557 27.4366C12.6231 28.0859 14.3034 28.419 15.9999 28.4168Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 23.8962C16.4281 23.8962 16.8387 23.7261 17.1415 23.4233C17.4443 23.1205 17.6144 22.7098 17.6144 22.2816C17.6144 21.8534 17.4443 21.4427 17.1415 21.1399C16.8387 20.8371 16.4281 20.667 15.9998 20.667C15.5716 20.667 15.1609 20.8371 14.8582 21.1399C14.5554 21.4427 14.3853 21.8534 14.3853 22.2816C14.3853 22.7098 14.5554 23.1205 14.8582 23.4233C15.1609 23.7261 15.5716 23.8962 15.9998 23.8962Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.75V18.0833",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmirationWhite);
export default __webpack_public_path__ + "static/media/admiration_white.33677f623fd0f86a4a3aacca9a63aa4a.svg";
export { ForwardRef as ReactComponent };